import {createContext} from "react";

const UserContext = createContext({ user: null });

export default UserContext;
